<template>
  <div style="margin-top: 20px; margin-bottom: 20px;">
    <h1 class="u">
      Редактировать заявку
    </h1>
    <div class="sub-nav">
      <router-link class="btn btn-default btn-sm" :to="{ name: 'claim-details', params: { id: claim.id }}">← Назад к Деталям заявки</router-link>
    </div>

    <div class="text-right">
      <a v-if="claim.id" class="red" href="#" @click.prevent="deleteClaim">удалить заявку</a>
    </div>

    <claim-edit-form
      :claim="claim"
      @after="handleAfter"
    />

  </div>
</template>

<script>
import { getClaim, deleteClaim } from '@/services/claim.service'
import claimEditForm from '@/components/forms/claim/ClaimEditForm'

export default {
  name: 'claim-edit',
  components: { claimEditForm },
  data () {
    return {
      claim: {
        id: null,
        text: '',
        datetime: '',
        client: ''
      },

      errors: {
        claim: {
          id: [],
          text: [],
          datetime: [],
          client: []
        },
        non_field_errors: []
      }
    }
  },
  mounted () {
    if (this.$route.params.id !== undefined) {
      this.claim.id = this.$route.params.id

      getClaim(this.claim.id).then((response) => {
        this.claim = response.data
      })
    }
  },
  methods: {
    deleteClaim () {
      deleteClaim(this.claim.id).then((response) => {
        this.showMsg('Заявка была удалена!', 'success', 'Успешно')
        this.$router.push({ name: 'claims' })
        return true
      }).catch(err => {
        this.fillErrors(this.errors.claim, err.response.data)

        if (this.errors.non_field_errors[0]) {
          this.$parent.$parent.showPopupMsg(this.errors.non_field_errors[0], 'error')
        }

        return false
      })
    },
    handleAfter (success) {
      console.log(success)
    },
    showMsg (text, type, title) {
      let foundRoot = false
      let $parent = this.$parent

      while (!foundRoot) {
        console.log($parent)
        if ($parent.$parent.$parent === undefined) {
          foundRoot = true
          $parent.showPopupMsg(text, type, title)
        } else {
          $parent = $parent.$parent
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// ClaimEdit.vue?1a22580e